import {
  styled,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import { useSearchParams } from "react-router-dom";

const StyledFormControl = styled(FormControl)(({ theme }) => ({
  minWidth: 154,
  "& .MuiOutlinedInput-root": {
    height: 35,
    fontSize: "0.875rem",
    borderRadius: 3,
    backgroundColor: theme.palette.background.default,
    boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.05)",
  },
  "& .MuiInputLabel-root": {
    fontSize: "0.875rem",
    top: -8,
    "&.MuiInputLabel-shrink": {
      top: 0,
    },
  },
}));

const CustomSelectInput = ({
  options = [],
  paramKey,
  label,
  placeholder = "Select an option",
}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const currentValue = searchParams.get(paramKey) || "";

  const handleChange = (e) => {
    const { value } = e.target;
    const newParams = new URLSearchParams(searchParams);

    if (!value || value === "all") {
      newParams.delete(paramKey);
    } else {
      newParams.set(paramKey, value);
    }

    setSearchParams(newParams);
  };

  return (
    <StyledFormControl size="small" variant="outlined">
      <InputLabel>{label}</InputLabel>
      <Select
        value={currentValue}
        onChange={handleChange}
        label={label}
        displayEmpty
      >
        <MenuItem value="all">
          <em>{placeholder}</em>
        </MenuItem>
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </StyledFormControl>
  );
};

export default CustomSelectInput;
